import { CardContent, ScrollArea } from '@ais-ui/ui-core';
import {
  AtonTargetInfo,
  BaseStationTargetInfo,
  DasTargetInfo,
  DroneTargetInfo,
  EnvironmentalTargetInfo,
  MethydTargetInfo,
  RadarTargetInfo,
  ShipInfo,
  TargetInfoType,
  TargetTypeEnum,
  VirtualAtonTargetInfo,
} from '@ais-ui/websockets';
import { BaseStationDetailsPanel } from './BaseStationDetailsPanel';
import { AtonDetailsPanel } from './AtonDetailsPanel';
import { VirtualAtonDetailsPanel } from './VirtualAtonDetailsPanel';
import { MethydDetailsPanel } from './MethydDetailsPanel';
import { EnvironmentalDetailsPanel } from './EnvironmentalDetailsPanel';
import { DasDetailsPanel } from './DasDetailsPanel';
import { RadarDetailsPanel } from './RadarDetailsPanel';
import { DroneDetailsPanel } from './DroneDetailsPanel';
import { ExtendedVesselDetailsPanel } from './ExtendedVesselDetailsPanel';
import { VesselResult } from '@ais-ui/api-spec/shipdb';
import { ShipDetailsPanel } from './ShipDetailsPanel';
import React from 'react';
import { TargetTab } from './TargetDetails';

interface TargetInfoDetailsProps {
  targetInfo: TargetInfoType;
  targetType: TargetTypeEnum;
  tab: TargetTab;
}

export const TargetInfoDetails = ({
  targetInfo,
  targetType,
  tab,
}: TargetInfoDetailsProps) => {
  return (
    <CardContent className="flex-1 flex flex-col overflow-hidden">
      <ScrollArea
        className="flex-grow p-0 overflow-y-auto"
        observeResize={false}
      >
        {targetType === TargetTypeEnum.BaseStation ? (
          <BaseStationDetailsPanel
            baseStationInfo={targetInfo as BaseStationTargetInfo}
          ></BaseStationDetailsPanel>
        ) : targetType === TargetTypeEnum.Aton ? (
          <AtonDetailsPanel
            atonInfo={targetInfo as AtonTargetInfo}
          ></AtonDetailsPanel>
        ) : targetType === TargetTypeEnum.VirtualAton ? (
          <VirtualAtonDetailsPanel
            virtualAtonInfo={targetInfo as VirtualAtonTargetInfo}
          ></VirtualAtonDetailsPanel>
        ) : targetType === TargetTypeEnum.Methyd ? (
          <MethydDetailsPanel
            methydInfo={targetInfo as MethydTargetInfo}
          ></MethydDetailsPanel>
        ) : targetType === TargetTypeEnum.Environmental ? (
          <EnvironmentalDetailsPanel
            environmentalInfo={targetInfo as EnvironmentalTargetInfo}
          ></EnvironmentalDetailsPanel>
        ) : targetType === TargetTypeEnum.Das ? (
          <DasDetailsPanel
            dasInfo={targetInfo as DasTargetInfo}
          ></DasDetailsPanel>
        ) : targetType === TargetTypeEnum.Radar ? (
          <RadarDetailsPanel
            radarInfo={targetInfo as RadarTargetInfo}
          ></RadarDetailsPanel>
        ) : targetType === TargetTypeEnum.Drone ? (
          <DroneDetailsPanel
            droneInfo={targetInfo as DroneTargetInfo}
          ></DroneDetailsPanel>
        ) : targetType === TargetTypeEnum.ExtendedVessel ? (
          <ExtendedVesselDetailsPanel
            shipInfo={targetInfo as VesselResult}
            tab={tab}
          ></ExtendedVesselDetailsPanel>
        ) : (
          <ShipDetailsPanel shipInfo={targetInfo as ShipInfo} tab={tab} />
        )}
      </ScrollArea>
    </CardContent>
  );
};
